// 本文件自动生成，要修改host地址，请修改project.config.js文件
module.exports = {
  host: ''
}



// WEBPACK FOOTER //
// ./src/utils/host-config.js